


import { default as Dropdown } from "./Dropdown"
import { default as DropdownMenu } from "./DropdownMenu"
import { default as FieldGroup } from "./FieldGroup"
import { default as Form } from "./Form"
import { default as FormButton } from "./FormButton"
import { default as FormLabel } from "./Label"
import { default as InputField } from "./InputField"
import { default as Select } from "./Select"
import { default as SelectField } from "./SelectField"
import { default as Textarea } from "./Textarea"

export const Forms = {
  FieldGroup,
  Form,
  FormButton,
  FormLabel,
  InputField,
  Select,
  SelectField,
  Textarea
}